interface StatsCardProps {
  label: string;
  value: string | number | React.ReactNode;
  description?: string;
  icon: React.ElementType;
  iconColor: string;
  descriptionColor?: string;
  children?: React.ReactNode;
  iconOffset?: string; // Custom right offset for specific icons
}

export function StatsCard({
  label,
  value,
  description,
  icon: Icon,
  iconColor,
  descriptionColor,
  children,
  iconOffset,
}: StatsCardProps) {
  return (
    <div className="bg-[var(--card)] rounded-card border border-[var(--border)] p-2.5 md:p-4 shadow-card relative overflow-hidden min-w-0">
      <div className="relative z-10 min-w-0">
        <div className="text-[10px] md:text-xs font-medium text-[var(--muted-foreground)] leading-tight mb-1 truncate">{label}</div>
        <div className="flex items-end gap-1 md:gap-3 mt-1 md:mt-2 flex-wrap min-w-0">
          {typeof value === 'string' || typeof value === 'number' ? (
            <div className="text-lg md:text-2xl font-bold text-[var(--foreground)] leading-tight truncate min-w-0">{value}</div>
          ) : (
            value
          )}
          {children}
        </div>
        {description && (
          <div
            className="text-[10px] md:text-xs mt-1 leading-tight truncate"
            style={{ color: descriptionColor || 'var(--muted-foreground)' }}
          >
            {description}
          </div>
        )}
      </div>
      <Icon
        className="hidden md:block w-12 h-12 md:w-20 md:h-20 opacity-10 absolute top-1/2 -translate-y-1/2"
        style={{ 
          color: iconColor,
          right: iconOffset || '-28px',
          strokeWidth: '1.5px',
          strokeLinecap: 'square',
          strokeLinejoin: 'miter',
        }}
      />
    </div>
  );
}